<template>
  <div>
    <!-- 添加弹窗 -->
    <el-dialog
      :title="'添加分账部门/门店'"
      :visible.sync="add"
      @close="handleClose('add')"
      width="571px"
    >
      <el-form
        key="keyRefreshAdd"
        :model="addForm"
        ref="ledgerAddForm"
        label-width="180px"
        size="medium"
      >
        <el-form-item label="部门/门店" prop="departmentId" :rules="[Validator.required()]">
          <treeselect
            class="tree-select form-select"
            :default-expand-level="1"
            noOptionsText="暂无选项"
            noResultsText="暂无选项"
            v-model="addForm.departmentId"
            placeholder="请输入"
            :normalizer="normalizer"
            :options="list"
            :class="'ledger-set-modal-tree-select'"
          />
        </el-form-item>
        <el-form-item
          label="最大分账比例"
          prop="subAccountRatioMax"
          error="未设置最大分账比例，请联系诺通付运营"
          :show-message="!addForm.subAccountRatioMax"
          :rules="[Validator.required()]"
        >
          {{ addForm.subAccountRatioMax ? addForm.subAccountRatioMax + '%' : '-' }}
        </el-form-item>
        <el-form-item
          label="收款方税号"
          prop="payeeTaxNo"
          :rules="[
            Validator.required(),
            Validator.checkWithFunc(() => searchByTaxNo(addForm.payeeTaxNo)),
          ]"
        >
          <el-input v-model="addForm.payeeTaxNo" class="w280" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item v-if="addForm.payeeName" label="收款方商户名称" prop="payeeName">
          {{ addForm.payeeName }}
        </el-form-item>
        <el-form-item
          label="分账比例"
          prop="subAccountRatio"
          :rules="[Validator.required(), Validator.checkWithFunc(() => checkNumber(addForm))]"
        >
          <el-input-number
            ref="ledgerInputNumber"
            class="ledger-set-number-input"
            :min="1"
            :max="100"
            v-model="computedProportionNum"
          ></el-input-number
          >&nbsp;&nbsp;&nbsp;%
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-switch v-model="addForm.status"> </el-switch>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            class="w280 ledger-comments-textarea"
            type="textarea"
            v-model="addForm.remark"
            maxlength="252"
            rows="4"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addDetail">确 定</el-button>
        <el-button @click="handleClose('add')">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 编辑弹窗 -->
    <el-dialog
      :title="'编辑分账部门/门店'"
      :visible.sync="edit"
      @close="handleClose('edit')"
      width="571px"
    >
      <el-form
        key="keyRefreshEdit"
        :model="editForm"
        ref="ledgerEditForm"
        label-width="180px"
        size="medium"
      >
        <el-form-item label="部门/门店" prop="departmentId" :rules="[Validator.required()]">
          <treeselect
            class="tree-select form-select"
            :default-expand-level="1"
            noOptionsText="暂无选项"
            noResultsText="暂无选项"
            v-model="editForm.departmentId"
            placeholder="请输入"
            :normalizer="normalizer"
            :options="list"
            :class="'ledger-set-modal-tree-select'"
          />
        </el-form-item>
        <el-form-item label="最大分账比例" prop="subAccountRatioMax">
          <span>{{ editForm.subAccountRatioMax ? editForm.subAccountRatioMax + '%' : '-' }}</span>
        </el-form-item>
        <el-form-item label="收款方税号" prop="payeeTaxNo">
          <span>{{ editForm.payeeTaxNo }}</span>
        </el-form-item>
        <el-form-item label="收款方商户名称" prop="payeeName">
          <span>{{ editForm.payeeName }}</span>
        </el-form-item>
        <el-form-item
          label="分账比例"
          prop="subAccountRatio"
          :rules="[
            Validator.required(),
            Validator.numberRequired(),
            Validator.checkWithFunc(() => checkNumber(editForm)),
          ]"
        >
          <el-input-number
            ref="ledgerInputNumber"
            class="ledger-set-number-input"
            :min="1"
            :max="100"
            v-model="computedProportionNum"
          ></el-input-number
          >&nbsp;%
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-switch v-model="editForm.status"> </el-switch>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            class="w280 ledger-comments-textarea"
            type="textarea"
            v-model="editForm.remark"
            maxlength="252"
            rows="4"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editDetail">确 定</el-button>
        <el-button @click="handleClose('edit')">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: 'EditFormModal',
  props: {
    addVisible: Boolean,
    editVisible: Boolean,
    editFormData: Object,
    departList: Array,
    pageObj: Object,
  },
  components: {
    Treeselect,
  },
  data() {
    return {
      add: false,
      edit: false,
      noSearch: false,
      list: [],
      pageData: {
        pageSize: 10,
        currentPage: 1,
      },
      addForm: {
        departmentId: null,
        payeeName: '',
        payeeCustomerNo: '',
        status: true,
        subAccountRatioMax: null,
        payeeTaxNo: '',
        subAccountRatio: 1,
        remark: '',
      },
      editForm: {
        id: '',
        departmentId: '',
        departmentName: null,
        payeeName: '',
        status: '',
        subAccountRatioMax: '',
        payeeTaxNo: '',
        subAccountRatio: '',
        remark: '',
      },
    };
  },
  created() {
    this.searchByTaxNo();
  },
  watch: {
    addVisible(newVal) {
      this.add = newVal;
    },
    editVisible(newVal) {
      this.edit = newVal;
    },
    editFormData(newVal) {
      this.editForm = newVal;
    },
    departList(newVal) {
      this.list = newVal;
    },
    pageObj(newVal) {
      this.pageData = newVal;
    },
  },
  computed: {
    computedProportionNum: {
      get() {
        if (this.editVisible) {
          return parseFloat(Number(this.editForm.subAccountRatio).toFixed(5));
        }
        if (this.addVisible) {
          return parseFloat(Number(this.addForm.subAccountRatio).toFixed(5));
        }
        return 0;
      },
      set(newVal) {
        const value = parseFloat(Math.round(Number(newVal) * Math.pow(10, 5)) / Math.pow(10, 5));
        if (this.editVisible) {
          this.editForm.subAccountRatio = value;
        }
        if (this.addVisible) {
          this.addForm.subAccountRatio = value;
        }
      },
    },
  },
  methods: {
    normalizer(node) {
      return {
        id: node.id,
        label: node.name,
        children: node.children,
      };
    },
    getTreeselectLabelName(options, id) {
      let departmentName = null;
      if (id !== '-1') {
        options.forEach((item) => {
          item.id === id && (departmentName = item.name);
          !departmentName &&
            item.children &&
            (departmentName = this.getTreeselectLabelName(item.children, id));
        });
      } else departmentName = '全公司';
      return departmentName;
    },
    async searchByTaxNo(taxNo) {
      // 根据税号查询商户
      let flag = false;
      const params = taxNo ? { taxNo: taxNo } : {};
      await this.api
        .post('/subaccount/config/queryCustomerInfo.do', params)
        .then(({ code, data }) => {
          if (code === 200) {
            if (!data) {
              flag = true;
            } else {
              if (!taxNo) {
                this.addForm.subAccountRatioMax = data.subAccountRatioMax;
                this.editForm.subAccountRatioMax = data.subAccountRatioMax;
              } else {
                this.addForm.payeeName = data.enterpriseName;
                this.addForm.payeeCustomerNo = data.customerNo;
              }
            }
          } else {
            this.addForm.payeeName = '';
            this.addForm.payeeCustomerNo = '';
            flag = true;
          }
        });
      taxNo || (flag = false);
      return {
        flag: flag,
        message: '未查询到该商户',
      };
    },
    checkNumber(formData) {
      const innerInput = this.$refs.ledgerInputNumber?.$refs?.input?.$refs?.input;
      if (!innerInput) return { flag: false, message: '' };
      const inputVal = Number(innerInput.value);
      const usefulVal = parseFloat(
        Math.round(Number(innerInput.value) * Math.pow(10, 5)) / Math.pow(10, 5),
      );
      if (!isNaN(inputVal) && usefulVal < inputVal) {
        innerInput.setAttribute('aria-valuenow', usefulVal);
        innerInput.value = usefulVal;
      }
      return {
        flag: formData.subAccountRatio > formData.subAccountRatioMax,
        message: '不得超过最大分账比例',
      };
    },
    resetSearchForm() {
      this.$refs.ledgerSetSearchForm.resetFields();
    },
    editDetail() {
      this.$refs.ledgerEditForm.validate((valid) => {
        if (valid) {
          const { payeeName, payeeTaxNo, payeeCustomerNo, taxNo, ...params } = this.editForm;
          params.departmentName = this.getTreeselectLabelName(
            this.list,
            this.editForm.departmentId,
          );
          this.api
            .post('/subaccount/config/editSubAccountConfig.do', params)
            .then(({ code, message }) => {
              if (code === 200) {
                this.handleClose('edit');
                this.$message.success(message);
              } else {
                this.$message.error(message);
              }
              this.$emit('getTableData', this.pageData);
            });
        }
      });
    },
    addDetail() {
      this.$refs.ledgerAddForm.validate((valid) => {
        if (valid) {
          this.addForm.departmentName = this.getTreeselectLabelName(
            this.list,
            this.addForm.departmentId,
          );
          this.api
            .post('/subaccount/config/addSubAccountConfig.do', this.addForm)
            .then(({ code, message }) => {
              if (code === 200) {
                this.handleClose('add');
                this.$message.success(message);
              } else {
                this.$message.error(message);
              }
              this.$emit('getTableData', this.pageData);
            });
        }
      });
    },
    handleClose(type) {
      this.$refs.ledgerAddForm?.resetFields();
      this.addForm.payeeName = '';
      this.addForm.payeeCustomerNo = '';
      this.departmentName = null;
      this.$emit('handleClose', type);
    },
  },
};
</script>
<style lang="scss">
.ledger-set-modal-tree-select > .vue-treeselect__control {
  height: 36px;
}
.ledger-settings {
  // 调整计数样式，使其不覆盖输入文本
  .ledger-comments-textarea {
    .el-textarea__inner {
      resize: none; // 去掉textarea右下角图案
      padding-bottom: 18px;
    }
    .el-input__count {
      height: 12px;
      line-height: 12px;
    }
  }
}
</style>
<style scoped lang="scss">
.ledger-set-modal-tree-select {
  width: 280px;
}
.w280 {
  width: 280px;
}
.ledger-set-number-input {
  width: 260px;
  margin-right: 8px;
}
.dialog-footer {
  margin-top: -20px;
  margin-right: 48px;
}
</style>
